export const workVersion = (task) => task.updatedOn || task.createdOn || "0001-01-01T00:00:00";
export const newestWorkFirst = (a, b) =>
  (new Date(workVersion(b)).getTime() || 0) -
    (new Date(workVersion(a)).getTime() || 0) || Number(b.id || 0) - Number(a.id || 0);
